import { Injectable, Input, OnDestroy, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

export enum LocalizationLanguages {
  En = 'en',
  Fr = 'fr',
}
@Injectable()
export abstract class BaseComponent implements OnInit, OnDestroy {
  @Input() id = 'default';

  readonly localizationLanguages = LocalizationLanguages;

  private subscriptions: Subscription[] = [];
  private queryParams: {
    [key: string]: unknown;
  };

  constructor() {}

  subscribe(sub: Subscription): void {
    this.subscriptions.push(sub);
  }

  ngOnInit(): void {
    this.onInit();
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((s) => {
        if (s) {
          s.unsubscribe();
        }
      });
    }
    this.onDestroy();
  }

  protected abstract onInit(): void;

  protected abstract onDestroy(): void;

  protected initQueryParam(key: string, activatedRoute: ActivatedRoute): void {
    if (!!activatedRoute.snapshot && !!activatedRoute.snapshot.queryParams) {
      this.setQueryParam(key, activatedRoute.snapshot.queryParams[key]);
    }
  }

  protected getQueryParam(key: string): unknown {
    return this.queryParams[key];
  }

  protected setQueryParam(key: string, value: unknown): void {
    if (this.queryParams) {
      this.queryParams[key] = value;
    }
  }
}
